/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Tawk_Widget_IdInputs */

const en_admin_settings_fields_tawk_widget_id = /** @type {(inputs: Admin_Settings_Fields_Tawk_Widget_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widget ID`)
};

const zh_admin_settings_fields_tawk_widget_id = /** @type {(inputs: Admin_Settings_Fields_Tawk_Widget_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widget ID`)
};

/**
* | output |
* | --- |
* | "Widget ID" |
*
* @param {Admin_Settings_Fields_Tawk_Widget_IdInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_tawk_widget_id = /** @type {((inputs?: Admin_Settings_Fields_Tawk_Widget_IdInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Tawk_Widget_IdInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_tawk_widget_id(inputs)
	return zh_admin_settings_fields_tawk_widget_id(inputs)
});
export { admin_settings_fields_tawk_widget_id as "admin.settings.fields.tawk_widget_id" }